module.exports = __webpack_public_path__ + "static/media/manageleave.475f6eb2.svg";